import React from 'react';
import T from 'prop-types';
import { Button, Tooltip } from 'antd';

import useToggle from '../../../../hooks/useToggle';
import * as Content from '../../../../attrs/content';

import CollapsibleCard from '../../../collapsibleCard';
import CancelSubscriptionButton from '../../../cancelSubscriptionButton';

import DeleteAccountConfirmModal from '../deleteAccountConfirmModal';
import DeleteAccountSuccessModal from '../deleteAccountSuccessModal';

import { StyledRow, StyledCol, InfoIcon } from './style';

const DangerZoneCard = ({ deleteAccountSuccess, isUserPaying }) => {
  const [isModalVisible, setModalVisibility] = useToggle(false);

  return (
    <CollapsibleCard title="Danger Zone">
      <StyledRow align="middle" type="flex">
        <StyledCol sm={12} span={24}>
          Delete your account permanently
        </StyledCol>
        <StyledCol sm={12} span={24}>
          <Button onClick={() => setModalVisibility(true)} type="danger">
            Delete Account
          </Button>
        </StyledCol>
      </StyledRow>

      {isUserPaying && (
        <StyledRow align="middle" type="flex">
          <StyledCol sm={12} span={24}>
            Cancel your subscription
            <Tooltip placement="right" title={Content.cancelationInfo}>
              <InfoIcon />
            </Tooltip>
          </StyledCol>
          <StyledCol sm={12} span={24}>
            <CancelSubscriptionButton />
          </StyledCol>
        </StyledRow>
      )}

      <DeleteAccountConfirmModal
        isVisible={isModalVisible && !deleteAccountSuccess}
        setVisibility={setModalVisibility}
      />
      <DeleteAccountSuccessModal isVisible={deleteAccountSuccess} />
    </CollapsibleCard>
  );
};

DangerZoneCard.propTypes = {
  deleteAccountSuccess: T.bool.isRequired,
  isUserPaying: T.bool.isRequired,
};

export default DangerZoneCard;
